import _slicedToArray from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import { useGlue } from '../hooks';
import React, { useCallback, useEffect, useState } from 'react';
import { GlueEvents } from '../glue';
export var ComponentKind;

(function (ComponentKind) {
  ComponentKind["ROUTER"] = "glue.router";
  ComponentKind["ACCESS_DENIED"] = "access_denied";
  ComponentKind["EDITOR"] = "glue.editor";
  ComponentKind["CHILDREN_BLOCKS"] = "glue.frontend.children_blocks";
  ComponentKind["APP_PROVIDER"] = "glue.app_provider";
})(ComponentKind || (ComponentKind = {}));

export function ComponentRender(params) {
  //@ts-ignore
  var kind = params.kind,
      componentParams = __rest(params, ["kind"]);

  var subParams = componentParams;
  var glue = useGlue();

  var _useState = useState(function () {
    return glue.getComponent(kind);
  }),
      _useState2 = _slicedToArray(_useState, 2),
      RenderComponent = _useState2[0],
      setComponent = _useState2[1];

  var refreshComponent = useCallback(function () {
    var component = glue.getComponent(kind);

    if (component !== RenderComponent) {
      setComponent(component);
    }
  }, [RenderComponent, glue]);
  useEffect(function () {
    return glue.on(GlueEvents.COMPONENTS_REFRESH, refreshComponent);
  }); //@ts-ignore

  if (RenderComponent) {
    //@ts-ignore
    return React.createElement(RenderComponent, Object.assign({}, subParams));
  }

  throw new Error("Component ".concat(kind, " may not exist, unable to render"));
}